var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.content,"placement":_vm.placement,"disabled":!_vm.isOverflow,"effect":"dark","popper-class":_vm.dynamicTooltipClass}},[_c('div',{ref:"textRef",staticClass:"text-tooltip-content",style:(_vm.contentStyle)},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c67c07c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextTooltip.vue
// module id = null
// module chunks = 